import { render, staticRenderFns } from "./mo-bulk-processing.html?vue&type=template&id=f1515616&external"
import script from "./mo-bulk-processing.ts?vue&type=script&lang=ts&external"
export * from "./mo-bulk-processing.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-bulk-processing.vue?vue&type=style&index=0&id=f1515616&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/5/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1515616')) {
      api.createRecord('f1515616', component.options)
    } else {
      api.reload('f1515616', component.options)
    }
    module.hot.accept("./mo-bulk-processing.html?vue&type=template&id=f1515616&external", function () {
      api.rerender('f1515616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-bulk-processing/mo-bulk-processing.vue"
export default component.exports